// @ts-check
(function(runtime) {
    var _ = runtime.components.dependencies._;
    var Modernizr = runtime.components.dependencies.Modernizr;

    var constants = runtime.components.constants.merge({
        descendantSelector: '.ixp-component-form[' + runtime.components.constants.components.data.componentRoot + ']',
        inputSelector: '.ixp-input-validate',
        fieldSelector: '.ixp-component-form-field',
        shownStatePrefix: '.ixp-component-form-shown-state-',
        hiddenStatePrefix: '.ixp-component-form-hidden-state-',

        behaviors: {
            submit: 'form-submit'
        },

        css: {
            fieldLayoutPrefix: 'ixp-component-form-field-layout-',
            hide: 'ixp-component-form-state-hide',
            validated: 'ixp-component-form-validated',
            notValidated: 'ixp-component-form-not-validated',
            submitted: 'ixp-component-form-submitted',
            notSubmitted: 'ixp-component-form-not-submitted',
            showValidation: 'ixp-component-form-show-validation',
            showStudioValidation: 'ixp-component-form-show-studio-validation',
            showValidationPrefix: 'ixp-component-form-show-validation-'
        },

        data: {
            inputType: 'data-ixp-input-type',
            submitBehavior: 'data-ixp-behavior-form-submit',
            submitBehaviorScope: 'data-ixp-behavior-scope-form-submit'
        },

        builtIn: {
            classes: [
                'ixp-component-form-default',
                'ixp-component-form-light',
                'ixp-component-form-dark'
            ],
            builtInClass: 'ixp-c-form-built-in'
        },

        validationModes: {
            onChange: 'onchange',
            onSubmit: 'onsubmit'
        },

        focusModes: {
            none: 'none',
            form: 'form',
            input: 'input'
        },

        field: {
            inputContainerSelector: '.ixp-component-form-field-input-container',
            labelContainerSelector: '.ixp-component-form-field-label-container',
            infoContainerSelector: '.ixp-component-form-field-info-container',
            shownStatePrefix: '.ixp-component-form-field-shown-state-',
            hiddenStatePrefix: '.ixp-component-form-field-hidden-state-',

            css: {
                hide: 'ixp-component-form-field-state-hide',
                validated: 'ixp-component-form-field-validated',
                notValidated: 'ixp-component-form-field-not-validated',
                fieldStartsWith: 'ixp-component-form-field-starts-with-',
                fieldEndsWith: 'ixp-component-form-field-ends-with-'
            },

            data: {
                fieldFor: 'data-ixp-component-form-field-for'
            }
        },

        extensibility: {
            commands: {
                status: ':status',
                submit: ':submit'
            },

            events: {
                submitting: ':submitting',
                submitted: ':submitted',
                status: ':status',
                validatedSubmitting: ':validated:submitting',
                formFieldInputRegistered: ':formFieldInput:registered'
            }
        }
    });

    runtime.components.registerExtensibility('ixp-form', {
        events: constants.extensibility.events || {},
        commands: constants.extensibility.commands || {}
    });

    var statics = {
        fieldCssClassesToPreserve: [
            constants.field.css.validated,
            constants.field.css.notValidated
        ],

        formCssClassesToPreserve: [
            constants.css.fieldLayoutPrefix + 'simple',
            constants.css.fieldLayoutPrefix + 'expanded',
            constants.css.validated,
            constants.css.notValidated,
            constants.css.submitted,
            constants.css.notSubmitted,
            constants.css.showValidation,
            constants.css.showStudioValidation
        ],

        getFieldScaffolding: function(scaffoldingKey, builder, options) {
            return {
                style: {
                    customClass: builder.getDefaultTheme('formfield')
                }
            };
        },

        getSubmitButtonScaffolding: function(scaffoldingKey, builder, options) {
            var attrs = {};
            var behaviorToken = builder.getBehaviorToken(constants.data.submitBehavior);
            if (behaviorToken) {
                attrs[constants.data.submitBehavior] = '';
                attrs[constants.data.submitBehaviorScope] = behaviorToken;
            }

            var container = builder.scaffoldContainer('Submit Container');
            var link = builder.scaffoldLink('Submit', 'Submit Button');
            link.content.htmlAttributes = attrs;
            link.style.customClass = 'button button-a button-medium';
            container.content.scaffolding = [link];

            return {
                scaffolding: [container],
                style: {
                    customClass: builder.getDefaultThemes({ 'formsubmitbutton': '', 'formsubmitbutton-alignment': '' })
                }
            };
        },

        getFormScaffolding: function(scaffoldingKey, builder, options) {
            var token = new Date().getTime() + "_form";
            builder.addBehaviors('ixp-form', token);

            var submitButton = builder.scaffold('ixp-form-submit-button', 'Submit Container');

            var attrs = {};
            attrs[constants.components.data.behaviorScopeOwner] = token;

            var container = builder.scaffoldContainer('Form');
            container.content.scaffolding = [submitButton];

            return {
                scaffolding: [container],
                style: {
                    customClass: builder.getDefaultThemes({
                        'customform': '',
                        'customform-layout': 'ixp-component-form-layout-top-labels',
                        'customform-validation-default': 'ixp-component-form-default-validation',
                        'customform-validation-labels': 'ixp-component-form-label-validation',
                        'customform-required-inputs': 'ixp-required-input-asterisk',
                        'customform-label-alignment': '',
                        'customform-label-vertical-alignment': ''
                    })
                },
                content: {
                    htmlAttributes: attrs
                }
            };
        },

        getWrapping: function(type, builder, options) {
            switch (type) {
                case 'ixp-textbox':
                case 'ixp-choice-group':
                case 'ixp-slider':
                case 'ixp-dropdown':
                    var formField = builder.scaffold('ixp-form-field', 'Form Field');

                    var elementId = builder.PendingContainerChildId + new Date().getTime();

                    var labelContainer = builder.scaffoldContainer('Label Container');
                    labelContainer.elementId = elementId + 'Label';
                    labelContainer.scaffoldContainerParameterId = 'label_container';
                    labelContainer.content.scaffolding = [builder.scaffoldText('Label', 'Label')];

                    var inputContainer = builder.scaffoldContainer('Form Field');
                    inputContainer.elementId = elementId + 'Input';
                    inputContainer.scaffoldContainerParameterId = 'input_container';
                    inputContainer.content.scaffolding = [options.element || builder.scaffold(type)];

                    formField.content.scaffolding = [labelContainer, inputContainer];

                    return formField;
            }
            return null;
        },

        getFirstAndLastInputTypes: function($inputs) {
            return [
                $inputs.first().attr(constants.inputs.data.inputType),
                $inputs.last().attr(constants.inputs.data.inputType)
            ];
        },

        parseInputStates: function($, $inputs, options) {
            options || (options = {});

            var results = {};
            if (options.aggregateSaves) {
                results.toBeSaved = [];
            }

            if (options.aggregateInstances) {
                results.instances = {};
            }

            if (options.aggregateTypes) {
                results.types = [];
            }

            options.index = 0;
            $inputs.each(function() {
                statics._parseInputState($, results, $(this), options);
                options.index++;
            });

            var result = {
                instances: results.instances,
                types: results.types,
                anyRequired: results.anyRequired,
                firstInvalidInputInstanceId: results.firstInvalidInputInstanceId
            };

            if (results.invalid) {
                result.validation = constants.inputs.states.invalid;
            } else if (results.incomplete) {
                result.validation = constants.inputs.states.incomplete;
            } else if (results.pending) {
                result.validation = constants.inputs.states.pending;
                result.inputsToBeSaved = results.toBeSaved;
            } else if (results.unknown || (results.toBeSaved && results.toBeSaved.length)) {
                result.validation = constants.inputs.states.unknown;
                result.inputsToBeSaved = results.toBeSaved;
            } else {
                result.validation = constants.inputs.states.valid;
            }

            return result;
        },

        _parseInputState: function($, result, $input, options) {
            if (options.aggregateTypes) {
                var inputType = $input.attr(constants.inputs.data.inputType);
                if ($.inArray(inputType, result.types) === -1) {
                    result.types.push(inputType);
                }
            }

            if (options.aggregateInstances) {
                var instanceId = $input.attr(constants.components.data.componentRoot);
                result.instances[instanceId] = {
                    instanceId: instanceId,
                    instance: runtime.components.instances[instanceId].instance,
                    index: options.index
                };
            }

            var state = $input.attr(constants.inputs.data.state);
            if (!state) {
                return result;
            }

            state = JSON.parse(state)

            result.anyRequired = result.anyRequired || state.required;

            var save;
            switch (state.validation) {
                case constants.inputs.states.invalid:
                    result.invalid = true;
                    if (!result.firstInvalidInputInstanceId) {
                        result.firstInvalidInputInstanceId = state.instanceId;
                    }
                    return false;
                case constants.inputs.states.incomplete:
                    result.incomplete = true;
                    if (!result.firstInvalidInputInstanceId) {
                        result.firstInvalidInputInstanceId = state.instanceId;
                    }
                    break;
                case constants.inputs.states.pending:
                    result.pending = true;
                    break;
                case constants.inputs.states.unknown:
                    if (state.requiresSave) {
                        result.unknown = true;
                        save = true;
                    }
                    break;
                default:
                    if (state.requiresSave) {
                        save = true;
                    }
                    break;
            }

            if (options.aggregateSaves && save) {
                result.toBeSaved.push({
                    instanceId: state.instanceId,
                    dataField: state.dataField,
                    value: state.value,
                    method: state.saveMethod
                });
            }

            return result;
        },

        usesBuiltInStyles: function($el) {
            var classList = constants.builtIn.classes;
            for (var i = 0, j = classList.length; i < j; i++) {
                if ($el.hasClass(classList[i])) {
                    return true;
                }
            }
            return false;
        }
    };

    runtime.components.register('ixp-form-field', {
        initialize: function(options) {
            var $form = this.$el.closest(constants.inputs.formSelector);
            this.formInstanceId = $form.attr(constants.components.data.componentRoot);

            this.$elInputContainer = this.$el.find(constants.field.inputContainerSelector);
            this.$elLabelContainer = this.$el.find(constants.field.labelContainerSelector);
            this.$elInfoContainer = this.$el.find(constants.field.infoContainerSelector);

            this.$containers = this.$elLabelContainer.add(this.$elInputContainer).add(this.$elInfoContainer);

            this.$elInputs = this._getInputs();

            this.state = {
                validation: constants.inputs.states.unknown
            };

            if (this.$elInputs.length) {
                this._setState();

                runtime.events.on(this, this.formInstanceId + constants.inputs.events.inputStateChanged, this._onInputStateChanged);

                for (var instanceId in this.state.inputs) {
                    if (this.state.inputs.hasOwnProperty(instanceId)) {
                        runtime.events.on(this, instanceId + constants.inputs.events.inputChanged, this._onInputChanged);
                        runtime.events.on(this, instanceId + constants.inputs.events.inputStateChanged, this._onInputStateChanged);

                        runtime.events.trigger(instanceId + constants.inputs.events.formFieldInputRegistered, { labelContainerSelector: this.$elLabelContainer.selector });
                    }
                }

                if (!this.inStudio) {
                    this.$elLabelContainer.on('click' + this.eventNamespace, _.bind(this._onLabelClicked, this));
                }
            }
        },

        _onInputChanged: function(e) {
            this._setState({ validated: true });
        },

        _onInputStateChanged: function(e) {
            this._setState();
        },

        _setState: function(options) {
            options || (options = {});

            var results = statics.parseInputStates(this.$, this.$elInputs, { aggregateInstances: true, aggregateTypes: true });
            this.state.inputs = results.instances;
            this.state.validation = results.validation;
            this.state.firstInvalidInputInstanceId = results.firstInvalidInputInstanceId;

            this.$el.toggleClass(constants.inputs.css.required, !!results.anyRequired);

            this._setChildrenAttributesOnField(results);

            if (this.state.validation !== constants.inputs.states.pending) {
                for (var state in constants.inputs.states) {
                    if (constants.inputs.states.hasOwnProperty(state)) {
                        this.$el.toggleClass(constants.inputs.css.validationPrefix + state, state === this.state.validation);
                    }
                }
            }

            if (!this.inStudio) {
                this.$containers.find('[class*="' + constants.field.hiddenStatePrefix.substring(1) + '"]', constants.descendantSelector)
                    .removeClass(constants.css.hide);
                this.$containers.find('[class*="' + constants.field.shownStatePrefix.substring(1) + '"]', constants.descendantSelector)
                    .addClass(constants.css.hide);

                this.$containers.find(constants.field.hiddenStatePrefix + this.state.validation, constants.descendantSelector)
                    .addClass(constants.css.hide);
                this.$containers.find(constants.field.shownStatePrefix + this.state.validation, constants.descendantSelector)
                    .removeClass(constants.css.hide);
            }

            if (!this.initializing && options.validated && this.state.validation !== constants.inputs.states.pending) {
                this.$el
                    .addClass(constants.field.css.validated)
                    .removeClass(constants.field.css.notValidated);
            }
        },

        _setChildrenAttributesOnField: function(results) {
            this.$el.attr(constants.field.data.fieldFor, results.types.join(','));

            // We only care about the first and last input in the field for CSS alignment + spacing
            var firstAndLastInputTypes = statics.getFirstAndLastInputTypes(this.$elInputs);
            var fieldStartsWithClass = constants.field.css.fieldStartsWith;
            var fieldEndsWithClass = constants.field.css.fieldEndsWith;

            // only used in CS when form field children are changed
            if (this.inStudio) {
                this.$el.removeClass(function(index, classList) {
                    classList = classList.split(' ');
                    var toRemove = [];
                    for (var i = 0; i < classList.length; i++) {
                        if (classList[i].indexOf(fieldStartsWithClass) > -1 || classList[i].indexOf(fieldEndsWithClass) > -1) {
                            toRemove.push(classList[i]);
                        }
                    }
                    return toRemove.join(' ');
                });
            }

            if (firstAndLastInputTypes[0]) {
                this.$el.addClass(fieldStartsWithClass + firstAndLastInputTypes[0]);
            }
            if (firstAndLastInputTypes[1]) {
                this.$el.addClass(fieldEndsWithClass + firstAndLastInputTypes[1]);
            }
        },

        _onLabelClicked: function(e) {
            var input;
            if (this.state.firstInvalidInputInstanceId) {
                input = this.state.inputs[this.state.firstInvalidInputInstanceId];
            } else {
                this.$.each(this.state.inputs, function() {
                    if (this.index === 0) {
                        input = this;
                        return false;
                    }
                });
            }

            if (input) {
                input.instance.setFocus();
            }
        },

        _getInputs: function() {
            return this.$elInputContainer.find('.' + constants.inputs.css.input);
        },

        allowedDropTargets: function() {
            return ['ixp-form'];
        },

        disallowedChildrenTypes: function(context) {
            if (this.$elInputContainer[0] !== context.target) {
                return ['ixp-textbox', 'ixp-slider', 'ixp-choice-group'];
            }
            return undefined;
        },

        onGetCssClassesToPreserve: function() {
            return statics.fieldCssClassesToPreserve;
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getFieldScaffolding(scaffoldingKey, builder, options);
        },

        onListenToStudioEvents: function(events) {
            events.on('container:children:changed', function(e) {
                if (e && e.source && this.$elInputContainer.find('#' + e.source).addBack('#' + e.source).length) {
                    this.$elInputs = this._getInputs();
                    this._setState();
                }
            }, this);
        }
    });

    runtime.components.register('ixp-form-submit-button', {
        initialize: function(options) { },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getSubmitButtonScaffolding(scaffoldingKey, builder, options);
        },

        allowedDropTargets: function() {
            return ['ixp-form'];
        }
    });

    runtime.components.register('ixp-form', {
        initialize: function(options) {
            this.state = {
                validation: constants.inputs.states.unknown
            };

            this.$shadowForm = this.$el.find('.ixp-component-form-shadow').first();
            this.$shadowFormSubmit = this.$shadowForm.find('.ixp-component-form-shadow-button').first();

            // Make sure we reset all the show-validation classes, to deal with deprecated micro-theme applications
            this.$el
                .toggleClass(constants.css.showValidationPrefix + constants.validationModes.onChange, this.validationMode === constants.validationModes.onChange)
                .toggleClass(constants.css.showValidationPrefix + constants.validationModes.onSubmit, this.validationMode === constants.validationModes.onSubmit);

            this._detectBuiltInClasses();

            this.validate();

            if (this.inStudio) {
                this.$el
                    .removeClass(constants.css.showValidation)
                    .addClass(constants.css.showStudioValidation);
                return;
            }

            this.$shadowForm.on('submit', _.bind(function(e) {
                if (this.customSubmitUrl) {
                    return;
                }
                e.preventDefault();
            }, this));

            this.$shadowForm.on('click', function(e) {
                e.stopPropagation();
            });

            runtime.events.on(this, this.instanceId + constants.inputs.events.inputChanged, this._onInputChanged);

            this.$el.on('keyup' + this.eventNamespace, _.bind(this._onKeyUp, this));

            this.onBehavior(this.$el, constants.behaviors.submit, this._onSubmitClicked, null, { delegate: false });
        },

        _detectBuiltInClasses: function() {
            this.$el.toggleClass(constants.builtIn.builtInClass, statics.usesBuiltInStyles(this.$el));
        },

        onListenToStudioEvents: function(events) {
            events.on('element:microtheme:applied element:microtheme:removed', _.bind(this._detectBuiltInClasses, this));
        },

        onGetCommandMap: function() {
            var commands = {};
            commands[constants.extensibility.commands.status] = { fn: this._onCommandStatus };
            commands[constants.extensibility.commands.submit] = { fn: this._onCommandSubmit };
            return commands;
        },

        _onCommandStatus: function(options) {
            var ee = {
                validation: this.state.validation,
                submitting: this._isSubmitting()
            };
            this.triggerExtensibility(constants.extensibility.events.status, ee, { done: options && options.done });
        },

        _onCommandSubmit: function(options) {
            var submitSelector = this.getBehaviorSelector(constants.behaviors.submit);
            var $submit = this.$(submitSelector).last();
            if (!$submit.length) {
                return;
            }

            _.defer(function(me) {
                me.preSubmitting = true;
                $submit.click();
            }, this);
        },

        validate: function(options) {
            options || (options = {});

            var $inputs = this.filterChildren(constants.inputSelector, constants.descendantSelector);
            var result = statics.parseInputStates(this.$, $inputs, { aggregateSaves: true });

            if (options.submit) {
                $inputs.addClass(constants.inputs.css.validated);
                this.filterChildren(constants.fieldSelector, constants.descendantSelector).addClass(constants.field.css.validated);
            }

            delete this.state.inputsToBeSaved;
            this.state.validation = result.validation;
            this.state.inputsToBeSaved = result.inputsToBeSaved;

            if (result.firstInvalidInputInstanceId) {
                this.state.firstInvalidInputInstanceId = result.firstInvalidInputInstanceId;
            } else {
                delete this.state.firstInvalidInputInstanceId;
            }

            this._setState();
        },

        setFocus: function() {
            this.$el[0].scrollIntoView();
        },

        _setState: function() {
            for (var state in constants.inputs.states) {
                if (constants.inputs.states.hasOwnProperty(state)) {
                    this.$el.toggleClass(constants.inputs.css.validationPrefix + state, state === this.state.validation);
                }
            }

            if (!this.inStudio) {
                this.filterChildren('[class*="' + constants.hiddenStatePrefix.substring(1) + '"]', constants.descendantSelector)
                    .removeClass(constants.css.hide);
                this.filterChildren('[class*="' + constants.shownStatePrefix.substring(1) + '"]', constants.descendantSelector)
                    .addClass(constants.css.hide);

                this.filterChildren(constants.hiddenStatePrefix + this.state.validation, constants.descendantSelector)
                    .addClass(constants.css.hide);
                this.filterChildren(constants.shownStatePrefix + this.state.validation, constants.descendantSelector)
                    .removeClass(constants.css.hide);
            }

            if (!this.initializing && this.state.validation !== constants.inputs.states.pending) {
                this.$el
                    .addClass(constants.css.validated)
                    .removeClass(constants.css.notValidated);
            }

            runtime.events.trigger(this.instanceId + constants.inputs.events.inputStateChanged, { instanceId: this.instanceId });
        },

        _onInputChanged: function(e) {
            this.validate();
        },

        _onKeyUp: function(e) {
            // Enter, Spacebar
            if (e.which !== 13 && e.which !== 32) {
                return;
            }

            var $submit = this.$(e.target);
            if ($submit.is('textarea') || $submit.parents('[' + constants.data.inputType + '=dropdown]').length) {
                return;
            }
            // Is the target a submit target?
            if ($submit.attr(constants.data.submitBehaviorScope) !== this.instanceId) {
                // Only allow spacebar submit on submit targets
                if (e.which === 32) {
                    return;
                }

                var submitSelector = this.getBehaviorSelector(constants.behaviors.submit);
                $submit = this.$(submitSelector).last();
                if (!$submit.length) {
                    return;
                }
            }

            e.stopPropagation();
            e.stopImmediatePropagation();
            e.preventDefault();

            _.defer(function(me) {
                me.preSubmitting = true;
                $submit.click({ interaction: { source: 'keyboard' }});
            }, this);
        },

        _isSubmitting: function() {
            return !!(this.preSubmitting || this.submitting ||
                (this.postSubmitTimestamp && this.postSubmitTimestamp >= (new Date()).getTime()));
        },

        _mapInputData: function(inputsToBeSaved) {
            var inputData = [];
            if (!inputsToBeSaved) {
                return inputData;
            }

            for (var i = 0; i < inputsToBeSaved.length; i++) {
                var input = inputsToBeSaved[i];
                var dataName = null;

                try {
                    dataName = JSON.parse(input.dataField).name;
                }
                catch (x) { }

                inputData.push({
                    name: dataName,
                    delete: input.method === 'DELETE',
                    value: input.value,
                    inputInstanceId: input.instanceId
                });
            }

            return inputData;
        },

        _onSubmitClicked: function(e) {
            this.preSubmitting = false;

            if (this.submitting) {
                e.stopPropagation();
                e.stopImmediatePropagation();
                e.preventDefault();

                this.log('_onSubmitClicked', 'aborted; already submitting');
                return;
            }

            if (this.postSubmitTimestamp && this.postSubmitTimestamp >= (new Date()).getTime()) {
                this.log('_onSubmitClicked', 'aborted; already submitting (timeout)');
                return;
            }

            if (this.state.validation === constants.inputs.states.pending) {
                e.stopPropagation();
                e.stopImmediatePropagation();
                e.preventDefault();

                this.log('_onSubmitClicked', 'aborted; pending');
                return;
            }

            this.submitting = true;

            runtime.events.trigger(this.instanceId + runtime.components.constants.inputs.events.formSubmitting, { instanceId: this.instanceId });

            var submitElement = e.target;
            var $submitElement = this.$(submitElement);

            var submitSelector = this.getBehaviorSelector(constants.behaviors.submit);
            if (!$submitElement.is(submitSelector)) {
                $submitElement = $submitElement.closest(submitSelector);
                if ($submitElement.length) {
                    submitElement = $submitElement[0];
                }
            }

            var ee = {
                data: this._mapInputData(this.state.inputsToBeSaved),
                cancel: false,
                submitElement: submitElement
            };
            this.triggerExtensibility(constants.extensibility.events.submitting, ee);

            if (ee.cancel) {
                e.stopPropagation();
                e.stopImmediatePropagation();
                e.preventDefault();

                this.log('_onSubmitClicked', 'aborted; cancelled');
                this.submitting = false;
                return;
            }

            this.validate({ submit: true });

            ee = {
                data: this._mapInputData(this.state.inputsToBeSaved),
                validation: this.state.validation,
                cancel: false,
                submitElement: submitElement
            };
            this.triggerExtensibility(constants.extensibility.events.validatedSubmitting, ee);

            if (ee.cancel) {
                e.stopPropagation();
                e.stopImmediatePropagation();
                e.preventDefault();

                this.log('_onSubmitClicked', 'aborted; cancelled');
                this.submitting = false;
                return;
            }

            this.$el.find('[class^="ixp-component-form-field-shown-state-"]').removeAttr('tabindex');
            this.$el.find('[class^="ixp-component-form-field-shown-state-"]:not(.ixp-component-form-state-hide)').attr('tabindex', '0');

            this.$el
                .addClass(constants.css.submitted)
                .removeClass(constants.css.notSubmitted);

            var submit = this.$(e.target).closest('[' + constants.inputs.data.submitUrl + ']', this.$el[0]);
            if (submit.length) {
                this.state.submitUrl = {
                    url: submit.attr(constants.inputs.data.submitUrl),
                    target: submit.attr('target')
                };
            } else {
                delete this.state.submitUrl;
            }

            if (this.state.validation === constants.inputs.states.invalid ||
                this.state.validation === constants.inputs.states.incomplete) {
                this.submitting = false;

                // @ts-ignore
                ee = {
                    validation: this.state.validation,
                    success: false
                };
                this.triggerExtensibility(constants.extensibility.events.submitted, ee);

                if (this.focusMode !== constants.focusModes.none) {
                    _.defer(function(me) {
                        if (me.focusMode === constants.focusModes.form) {
                            me.setFocus();
                        } else if (me.focusMode === constants.focusModes.input) {
                            me.sendCommand(constants.extensibility.inputs.commands.focus, me.state.firstInvalidInputInstanceId, { instanceId: me.state.firstInvalidInputInstanceId });
                        }
                    }, this);
                }
            } else {
                var submitOptions = {
                    success: _.partial(this._onSubmitComplete, {
                        submitUrl: this.state.submitUrl,
                        eventTarget: e.target
                    }),
                    error: function() {
                        this.submitting = false;
                        this.validate();
                    }
                };

                if (e.data && e.data.interaction) {
                    submitOptions.interaction = e.data.interaction;
                }

                if (this.state.validation === constants.inputs.states.pending) {
                    var pendingTimer = window.setInterval(_.bind(function() {
                        if (this.state.validation === constants.inputs.states.pending) {
                            return;
                        }
                        window.clearInterval(pendingTimer);

                        this.submit(submitOptions);
                    }, this), 50);
                } else {
                    this.submit(submitOptions);
                }
            }

            e.stopPropagation();
            e.stopImmediatePropagation();
            e.preventDefault();
        },

        submit: function(options) {
            var onSuccess = function(response) {
                this._processResponse(response, this.state.inputsToBeSaved);
                options.success.call(this);
            };

            var onError = function(xhr) {
                if (xhr.status === 409) {
                    var response = JSON.parse(xhr.responseText);
                    this._processResponse(response.responseStatus.data, this.state.inputsToBeSaved);
                }
                options.error.call(this);
            };

            this.log('submit', 'submitting', this.state.inputsToBeSaved);

            this.pushInteraction(_.assign({
                name: 'form submit',
                source: 'click'
            }, options.interaction  || {}));

            this.submitData({
                data: this.state.inputsToBeSaved,
                success: onSuccess,
                error: onError
            });
        },

        _processResponse: function(response, inputsToBeSaved) {
            if (!inputsToBeSaved || !inputsToBeSaved.length) {
                return;
            }

            var inputRsp,
                e;

            // Assume that the order we save is the order of the response
            for (var i = 0; i < inputsToBeSaved.length; i++) {
                inputRsp = response[i];

                e = {
                    instanceId: inputsToBeSaved[i].instanceId,
                    value: inputRsp.value,
                    validation: inputRsp.validation
                };
                runtime.events.trigger(e.instanceId + constants.inputs.events.inputSaved, e);
            }
        },

        _onSubmitComplete: function(options) {
            this.submitting = false;
            this.validate();

            var ee = {
                validation: this.state.validation,
                success: this.state.validation === constants.inputs.states.valid,
                preventDefault: false,
                customSubmitUrl: undefined,
                customSubmitMethod: 'POST'
            };
            this.triggerExtensibility(constants.extensibility.events.submitted, ee);

            if (ee.customSubmitUrl) {
                this.customSubmitUrl = ee.customSubmitUrl;
                ee.customSubmitMethod || (ee.customSubmitMethod = 'POST');

                this.$shadowForm.attr('action', ee.customSubmitUrl);
                this.$shadowForm.attr('method', ee.customSubmitMethod);

                this.log('_onSubmitComplete', 'custom submit url provided, customSubmitUrl=' + ee.customSubmitUrl + ', customSubmitMethod=' + ee.customSubmitMethod);

                this.$shadowForm.submit();

                return;
            }

            if (ee.preventDefault) {
                this.log('_onSubmitComplete', 'prevented');
                return;
            }

            if (this.state.validation !== constants.inputs.states.valid) {
                this.log('_onSubmitComplete', 'invalid');
                return;
            }

            this.$shadowFormSubmit.click();

            if (options.submitUrl && options.submitUrl.url) {
                this.log('_onSubmitComplete', 'valid - url', options.submitUrl.url);
                switch (options.submitUrl.target) {
                    case '_blank':
                        window.open(options.submitUrl.url, '_blank');
                        break;
                    case "_parent":
                        window.parent.location.assign(options.submitUrl.url);
                        break;
                    case "_top":
                        window.top.location.assign(options.submitUrl.url);
                        break;
                    default:
                        window.location.assign(options.submitUrl.url);
                        break;
                }
            } else if (options.eventTarget) {
                this.log('_onSubmitComplete', 'valid - click', options.eventTarget);
                this.postSubmitTimestamp = (new Date()).getTime() + 250;

                // For some reason the Android 4.0 browser won't always have a click function - so if not we will try createEvent
                // For some reason the IE8 says the click function is an object, so check for that
                if (typeof options.eventTarget.click === 'function' ||
                    typeof options.eventTarget.click === 'object') {
                    try {
                        options.eventTarget.click();
                        return;
                    } catch (ex) { }
                }

                var ce;
                if (document.createEvent) {
                    ce = document.createEvent('MouseEvents');
                    ce.initEvent('click', true, true);
                    options.eventTarget.dispatchEvent(ce);
                }
                // @ts-ignore
                else if (document.createEventObject) {
                    // @ts-ignore
                    ce = document.createEventObject();
                    options.eventTarget.fireEvent('onclick', ce);
                }
            }
        },

        studioInitialize: function(options) {
            this._studioSetFieldLayout();
        },

        _studioSetFieldLayout: function() {
            var infoContainers = this.filterChildren(constants.field.infoContainerSelector, constants.descendantSelector);

            if (this.fieldLayout === 'simple') {
                infoContainers.attr(constants.components.studio.data.hidden, true);
            } else if (this.fieldLayout === 'expanded') {
                infoContainers.removeAttr(constants.components.studio.data.hidden);
            }
        },

        getParamMapOverrides: function() {
            return {
                fieldLayout: function(val) {
                    this.$el.removeClass(constants.css.fieldLayoutPrefix + this.fieldLayout);
                    this.fieldLayout = val;
                    this.$el.addClass(constants.css.fieldLayoutPrefix + this.fieldLayout);

                    this._studioSetFieldLayout();
                    this.studioApp.componentsManager.trigger(constants.components.studio.events.reflow, { instanceId: this.instanceId });
                },

                validationMode: function(val) {
                    this.$el.removeClass(constants.css.showValidationPrefix + this.validationMode);
                    this.validationMode = val;
                    this.$el.addClass(constants.css.showValidationPrefix + this.validationMode);
                }
            };
        },

        allowedDropTargets: function() {
            return ['Container', 'Column'];
        },

        onGetCssClassesToPreserve: function() {
            return statics.formCssClassesToPreserve;
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getFormScaffolding(scaffoldingKey, builder, options);
        },

        onGetWrapping: function(type, builder, options) {
            return statics.getWrapping(type, builder, options);
        }
    });
    // @ts-ignore
})(window.ixp.runtime);
